import { useDispatch } from 'react-redux';
import { openDialog } from '../../base/dialog/actions';
import LayoutDialog from '../../video-menu/components/web/LayoutDialog';
import MuteAllDialog from '../../video-menu/components/web/MuteAllDialog';
import MuteAllVideoDialog from '../../video-menu/components/web/MuteAllVideoDialog';
import MuteEveryoneDialog from '../../video-menu/components/web/MuteEveryoneDialog';
import MuteEveryonesVideoDialog from '../../video-menu/components/web/MuteEveryonesVideoDialog';
import UnMuteAllDialog from '../../video-menu/components/web/UnMuteAllDialog';
import UnMuteAllVideoDialog from '../../video-menu/components/web/UnMuteAllVideoDialog';
import DialogPinParticipant from '../dialogs/DialogPinParticipant';
import { CONTROLER_ACTION_KEYS } from '../components/constant';
import { sendCommand } from '../../mod-command/slice';
import { COMMANDS } from '../../mod-command/constants';
const useCoordinateMeeting = () => {
    const dispatch = useDispatch();
    const handleClick = (key) => {
        switch (key) {
            case 'turnOffAllMicro':
                dispatch(openDialog(MuteEveryoneDialog));
                break;
            case 'turnOffAllMedia':
                dispatch(openDialog(MuteEveryonesVideoDialog));
                break;
            case 'turnOffAllMicroSIP':
                dispatch(openDialog(MuteAllDialog));
                break;
            case 'turnOnAllMicroSIP':
                dispatch(openDialog(UnMuteAllDialog));
                break;
            case 'turnOffAllMediaSIP':
                dispatch(openDialog(MuteAllVideoDialog));
                break;
            case 'turnOnAllMediaSIP':
                dispatch(openDialog(UnMuteAllVideoDialog));
                break;
            case 'pinnedForAll':
                dispatch(openDialog(DialogPinParticipant));
                break;
            case 'controlLayout':
                dispatch(openDialog(LayoutDialog));
                break;
            case CONTROLER_ACTION_KEYS.SORT_PARTICIPANTS_CTH:
                dispatch(sendCommand(COMMANDS.SORT_PARTICIPANTS.COMMANDS, undefined, true));
                break;
        }
    };
    return {
        handleClick
    };
};
export default useCoordinateMeeting;
